
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DLCompany } from './company';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const CompaniesQuery = require('./gql/company/companies.query.gql');
const CompanyQuery = require('./gql/company/company.query.gql');
const createDLCompanyMutation = require('./gql/company/create-company.mutation.gql');
const updateDLCompanyMutation = require('./gql/company/update-company.mutation.gql');
const deleteDLCompanyMutation = require('./gql/company/delete-company.mutation.gql');

export interface DLCompaniesQueryResult {
  companies: DLCompany[]
  companiesCount: number
}

export type DLCompanyOrderBy = 'NAME' | 'CREATED_AT';
export type DLCompanyOrderByDirection = 'ASC' | 'DESC';

export class DLCompanyFilter {
  offset: number
  limit: number

  search = '';
  orderBy: DLCompanyOrderBy = 'NAME';
  orderDir: DLCompanyOrderByDirection = 'ASC';
}


@Injectable()
export class DLCompanyService {

  constructor(private apollo: Apollo) { }

  companies(filter: DLCompanyFilter): Observable<DLCompaniesQueryResult> {
    return this.apollo
      .query({
        query: CompaniesQuery,
        variables: {
          filter
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map((result) => {
        let items = result.data['dlCompanies']['items'];
        let total = result.data['dlCompanies']['total'];

        items = _map(items, item => new DLCompany(item));

        return {
          companies: items,
          companiesCount: total,
        };
      }));
  }

  company(id: string): Observable<DLCompany> {
    return this.apollo
      .query({
        query: CompanyQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['dlCompany'] ? new DLCompany(result.data['dlCompany']) : null));
  }

  create(company: DLCompany): Observable<DLCompany> {
    return this.apollo
      .mutate({
        mutation: createDLCompanyMutation,
        variables: {
          input: company.toCreateDLCompanyInput()
        }
      }).pipe(
      map(result => new DLCompany(result.data['createDLCompany'])));
  }

  update(id: string, company: DLCompany): Observable<DLCompany> {
    return this.apollo
      .mutate({
        mutation: updateDLCompanyMutation,
        variables: {
          id,
          input: company.toUpdateDLCompanyInput()
        }
      }).pipe(
      map(result => new DLCompany(result.data['updateDLCompany'])));
  }

  delete(id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDLCompanyMutation,
        variables: {
          id
        }
      }).pipe(
      map(result => result.data['deleteDLCompany']));
  }
}
